import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  TitleProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ShowButton,
  TextField,
} from 'react-admin'
import { EngineMediaPackDto } from '../../../../core/dto/engine-media/engine-media-pack.dto'

const validateEngineMediaPackEdit = (values: EngineMediaPackDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.description) {
    errors.description = 'ra.validation.required'
  }
  return errors
}

interface EngineMediaPackTitleProps extends TitleProps {
  record?: EngineMediaPackDto
}

const EditTitle = (data: EngineMediaPackTitleProps) => {
  const { record: action } = data
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.engine-media-packs.titles.edit')}: {action?.id}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EngineMediaPackEdit = (props: EditProps) => (
  <Edit {...props} hasShow={false} title={<EditTitle />}>
    <SimpleForm
      redirect="show"
      toolbar={<EditToolbar />}
      validate={validateEngineMediaPackEdit}
    >
      <TextField source="id" label="ID" />
      <TextInput source="description" />
    </SimpleForm>
  </Edit>
)
